import { Navigate } from "react-router-dom";
import { useAuth } from "./auth.provider";

export default function RequirePermission({ permission, children }) {
	const { can } = useAuth();

	if (!can(permission)) {
		return <Navigate to="/forbidden" replace />;
	}

	return children;
}